import {html} from "@isceco/widget-library2/external/lit";
import WebComponent from "../../WebComponent";
import VerfuegungColumns from "./VerfuegungColumns";
import KontingentService from "../../services/KontingentService";
import KontingentperiodeService from "../../services/KontingentperiodeService";
import KontingentperiodeDto from "../Dashboard/KontingentperiodeDto";
import KontingentDto from "./KontingentDto";
import ConjunctiveListService from "../../services/ConjunctiveListService";

import '@isceco/widget-library2/basic-elements/Filter/DateFilter.js'
import '@isceco/widget-library2/basic-elements/Filter/FilterGroup.js'
import '@isceco/widget-library2/basic-elements/Filter/MultiselectFilter'
import '@isceco/widget-library2/basic-elements/Filter/StringFilter.js'
import '@isceco/widget-library2/basic-elements/Form/Form'
import '@isceco/widget-library2/basic-elements/ModalDialog/ModalDialog'
import '@isceco/widget-library2/basic-elements/NumberInput/NumberInput'
import '@isceco/widget-library2/basic-elements/Textarea/Textarea'
import '@isceco/widget-library2/basic-elements/TextInput/TextInput'
import '@isceco/widget-library2/basic-elements/Title/Title.js'
import {List} from "@isceco/widget-library2/basic-elements/List/List";

export default class VerfuegungPendent extends WebComponent {

  constructor() {
    super()
    this.kontingentService = new KontingentService()
    this.kontingentperiodeService = new KontingentperiodeService()
    this.wertAnpassen = null
  }

  get translationFile() {
    return './views/Verfuegung/i18n.json'
  }

  connectedCallback() {
    super.connectedCallback()
    this.reload()
  }

  reload() {
    Promise.all([
      this.kontingentperiodeService.read(getNavigationId()),
      this.kontingentService.getBackendListUrl()
    ]).then(([periode, url]) => {
      this.periode = new KontingentperiodeDto(periode)
      this.url = constructURL({to: url, params: [
        ['periodeId', getNavigationId()],
        ['status', 'VERSENDET_ELEKTRONISCH'],
        ['status', 'VORBEREITET_POSTALISCH'],
        ['status', 'VERSENDET_POSTALISCH']
      ]})
      this.render()
    }).catch(_ => {
      this.periode = new KontingentperiodeDto()
      this.url = ''
      this.render()
    })
  }

  getTemplate() {
    const start = formatDate(this.periode.start)
    const ende = formatDate(this.periode.ende)
    return html`
      <isceco-title id="page-title" text="${this.i18n.translate(`verfuegung.pendent.uebersicht.title`, {start, ende})}">
      </isceco-title>
      <isceco-filter-group>
        <isceco-string-filter label="${this.i18n.translate('verfuegung.filter.freitext')}"
                              key="freitext"
        ></isceco-string-filter>
        <isceco-date-filter label="${this.i18n.translate('verfuegung.filter.versanddatum')}"
                            key="versanddatum">
        </isceco-date-filter>
        <isceco-multiselect-filter label="${this.i18n.translate('verfuegung.filter.status')}"
                                    key="status"
                                    .items="${[
                                      {value: 'VERSENDET_ELEKTRONISCH', name: this.i18n.translate('verfuegung.status.versendet_elektronisch')},
                                      {value: 'VORBEREITET_POSTALISCH', name: this.i18n.translate('verfuegung.status.vorbereitet_postalisch')},
                                      {value: 'VERSENDET_POSTALISCH', name: this.i18n.translate('verfuegung.status.versendet_postalisch')}
                                    ]}"
        ></isceco-multiselect-filter>
      </isceco-filter-group>
      <isceco-list url="${this.url}"
                   identifier="kontingent"
                   .listService="${ConjunctiveListService}"
                   .i18n="${this.i18n}"
                   .dtoMapper="${this.toDTO}"
                   .columns="${VerfuegungColumns.getPendentColumns(this._preview, this._toggleVersenden)}"
      ></isceco-list>
      ${this._renderConfirmVersendenDialog()}
    `
  }

  _renderConfirmVersendenDialog() {
    if (!this.kontingentVersenden) {
      return html``
    }
    return html`
      <isceco-dialog id="versenden-dialog"
                     header="${this.i18n.translate(`verfuegung.pendent.versenden.title`, {gp: this.kontingentVersenden.gp})}"
                     description="${this.i18n.translate(`verfuegung.pendent.versenden.description`, {gp: this.kontingentVersenden.gp})}"
                     confirm-button="${this.i18n.translate(`verfuegung.pendent.versenden.button`)}"
                     cancel-button="${this.i18n.translate('base.button.cancel')}"
                     @submit="${e => this._handleVersenden(e.detail)}"
      ></isceco-dialog>
    `
  }

  _handleVersenden(event) {
    if (!event.confirmed) {
      this._toggleVersenden(null)
    } else {
      const filename = `${this.kontingentVersenden.geschaeftspartner.extId}_${this.kontingentVersenden.gp}_${formatDate(this.kontingentVersenden.periode.start)}`
      this.kontingentService.versenden(this.kontingentVersenden)
        .then(response => response.headers.get('Content-Type') === 'application/pdf' ? response.blob() : null)
        .then(pdf => pdf ? download(toValidFilename(filename, 'pdf'), pdf) : null)
        .then(_ => {
          window.showAlert(this.i18n.translate('verfuegung.pendent.versenden.alert.success', {gp: this.kontingentVersenden.gp}), "", 'success')
          send(List.EVENT_KEYS.RELOAD_TRIGGERED, {identifier: 'kontingent'})
          this._toggleVersenden(null)
        })
    }
  }

  _preview = kontingentDto => {
    const filename = `${kontingentDto.geschaeftspartner.extId}_${kontingentDto.gp}_${formatDate(kontingentDto.periode.start)}`
    this.kontingentService.read(kontingentDto.id, 'pdf')
      .then(response => response.blob())
      .then(blob => download(toValidFilename(filename, 'pdf'), blob))
  }

  _toggleVersenden = target => {
    this.kontingentVersenden = target;
    this.render()
  }

  toDTO = row => new KontingentDto(row)
}
customElements.define('eko-frontend-verfuegung-pendent', VerfuegungPendent)
